<template>
  <b-notification type="is-warning is-light" :closable="false" class="mb-0 p-3 is-size-7" data-test-id="deprecation-notice">
    <i18n path="deprecation.message" tag="span">
      <template #icon><i class="fa-regular fa-sparkles" data-test-id="deprecation-notice-icon"></i></template>
    </i18n>
  </b-notification>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class DeprecationNotice extends Vue {}
</script>
